import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Nav } from '@/components/generals/nav'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children, variant = 'default' }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col' style={{ color: 'var(--fz-ink)' }}>
            <Nav variant={variant} />

            <main className='flex-1'>
                {children}
            </main>

            {variant === 'default' && <Footer />}
        </div>
    )
}
